// test1345
(1345 && 0);
